import RolesUtil from 'permissions/utils/roles';
const StatementPermissions = {
  canCreate: (stateData) => {
    return (
      RolesUtil.doesUserHavePPMDRoleForProject(stateData) ||
      RolesUtil.doesUserHaveEngagementOwnerRoleForProject(stateData) ||
      RolesUtil.doesUserHavePreparerReviewerRoleForProject(stateData) ||
      RolesUtil.doesUserHaveAdminSupportAccess(stateData)
    );
  },
  canUploadRevision: (stateData) => {
    return (
      RolesUtil.doesUserHavePPMDRoleForProject(stateData) ||
      RolesUtil.doesUserHaveEngagementOwnerRoleForProject(stateData) ||
      RolesUtil.doesUserHavePreparerReviewerRoleForProject(stateData)
    );
  },
  canChangeContent: (stateData) => {
    return (
      RolesUtil.doesUserHavePPMDRoleForProject(stateData) ||
      RolesUtil.doesUserHaveEngagementOwnerRoleForProject(stateData) ||
      RolesUtil.doesUserHavePreparerReviewerRoleForProject(stateData)
    );
  },
  canEdit: (stateData) => {
    return (
      RolesUtil.doesUserHavePPMDRoleForProject(stateData) ||
      RolesUtil.doesUserHaveEngagementOwnerRoleForProject(stateData) ||
      RolesUtil.doesUserHavePreparerReviewerRoleForProject(stateData) ||
      RolesUtil.doesUserHaveAdminSupportAccess(stateData)
    );
  },
  canManageLegalHold: (stateData) => {
    return (
      RolesUtil.doesUserHavePPMDRoleForProject(stateData) ||
      RolesUtil.doesUserHaveEngagementOwnerRoleForProject(stateData) ||
      RolesUtil.doesUserHaveAdminSupportAccess(stateData)
    );
  },
  canSoftDelete: (stateData) => {
    return (
      RolesUtil.doesUserHavePPMDRoleForProject(stateData) ||
      RolesUtil.doesUserHaveEngagementOwnerRoleForProject(stateData) ||
      RolesUtil.doesUserHavePreparerReviewerRoleForProject(stateData) ||
      RolesUtil.doesUserHaveAdminSupportAccess(stateData)
    );
  },
  canSeeDisplayValueOfModifiedStatement: (stateData) => {
    return RolesUtil.doesUserHaveAdminSupportAccess(stateData);
  },
  canRestoreSoftDeleted: (stateData) => {
    return (
      RolesUtil.doesUserHavePPMDRoleForProject(stateData) ||
      RolesUtil.doesUserHaveEngagementOwnerRoleForProject(stateData) ||
      RolesUtil.doesUserHaveAdminSupportAccess(stateData)
    );
  },
  canPermanentlyDelete: (stateData) => {
    return (
      RolesUtil.doesUserHavePPMDRoleForProject(stateData) ||
      RolesUtil.doesUserHaveEngagementOwnerRoleForProject(stateData) ||
      RolesUtil.doesUserHaveAdminSupportAccess(stateData)
    );
  },
  canApproveWrapUp: (stateData) => {
    return (
      RolesUtil.doesUserHavePPMDRoleForProject(stateData) ||
      RolesUtil.doesUserHaveEngagementOwnerRoleForProject(stateData)
    );
  },
  canSubmmitForWrapUpApproval: (stateData) => {
    return (
      RolesUtil.doesUserHavePPMDRoleForProject(stateData) ||
      RolesUtil.doesUserHaveEngagementOwnerRoleForProject(stateData) ||
      RolesUtil.doesUserHavePreparerReviewerRoleForProject(stateData)
    );
  },
};
export default StatementPermissions;
